const FontStyleName = {
    0: "normal",
    1: "italic",
};

const getFontStyleName = (fontStyle) => {
    if (typeof fontStyle == "string") return fontStyle.toLowerCase();
    return FontStyleName[fontStyle] || "normal";
};

const getFontFormat = (url = "") => {
    const path = url.split("?")[0].toLowerCase();
    if (path.endsWith(".ttf")) return "truetype";
    if (path.endsWith(".otf")) return "opentype";
    if (path.endsWith(".woff2")) return "woff2";
    if (path.endsWith(".woff")) return "woff";
    return "";
};

const getFontPriority = (url = "") => {
    const path = url.split("?")[0].toLowerCase();
    if (path.endsWith(".woff2")) return 0;
    if (path.endsWith(".woff")) return 1;
    if (path.endsWith(".ttf")) return 2;
    if (path.endsWith(".otf")) return 3;
    return 4;
};

const getPreferredTextInfo = (textInfos = []) => {
    return [...textInfos].filter((item) => item && item.url).sort((a, b) => getFontPriority(a.url) - getFontPriority(b.url))[0];
};

const canvasToBlob = (canvas) =>
    new Promise((resolve) => {
        canvas.toBlob((blob) => resolve(blob), "image/png", 0.92);
    });

const cropTransparentCanvas = (source, padding = 4) => {
    const ctx = source.getContext("2d");
    if (!ctx) return source;
    const { width, height } = source;
    const imageData = ctx.getImageData(0, 0, width, height);
    const data = imageData.data;
    let minX = width;
    let minY = height;
    let maxX = -1;
    let maxY = -1;

    for (let y = 0; y < height; y++) {
        for (let x = 0; x < width; x++) {
            const alpha = data[(y * width + x) * 4 + 3];
            if (alpha === 0) continue;
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }
    }

    if (maxX < minX || maxY < minY) return source;

    minX = Math.max(0, minX - padding);
    minY = Math.max(0, minY - padding);
    maxX = Math.min(width - 1, maxX + padding);
    maxY = Math.min(height - 1, maxY + padding);

    const cropWidth = maxX - minX + 1;
    const cropHeight = maxY - minY + 1;
    const target = document.createElement("canvas");
    target.width = cropWidth;
    target.height = cropHeight;
    const targetCtx = target.getContext("2d");
    if (!targetCtx) return source;
    targetCtx.clearRect(0, 0, cropWidth, cropHeight);
    targetCtx.drawImage(source, minX, minY, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);
    return target;
};

export const CreateFontThumbnailFile = async (stockFont = {}) => {
    if (typeof document == "undefined" || !window.FontFace) return null;
    const textInfo = getPreferredTextInfo(stockFont.textInfos || []);
    if (!textInfo || !textInfo.url) return null;

    const family = `font-preview-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    const format = getFontFormat(textInfo.url);
    const src = format ? `url("${textInfo.url}") format("${format}")` : `url("${textInfo.url}")`;
    const weight = Number(textInfo.fontWeight || stockFont.fontWeight || 500) || 500;
    const style = getFontStyleName(textInfo.fontStyle);
    const fontFace = new FontFace(family, src, {
        weight: String(weight),
        style,
        display: "swap",
    });
    const loadedFont = await fontFace.load();
    document.fonts.add(loadedFont);

    const width = 1200;
    const height = 320;
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    if (!ctx) return null;

    ctx.clearRect(0, 0, width, height);

    const sample = stockFont.text || stockFont.fontFamily || "Ranus";
    let fontSize = 72;
    ctx.textBaseline = "top";
    ctx.fillStyle = stockFont.color || "#111111";
    ctx.font = `${style} ${weight} ${fontSize}px "${family}"`;

    const maxTextWidth = width - 80;
    while (fontSize > 28 && ctx.measureText(sample).width > maxTextWidth) {
        fontSize -= 4;
        ctx.font = `${style} ${weight} ${fontSize}px "${family}"`;
    }

    ctx.fillText(sample, 40, 40);
    const croppedCanvas = cropTransparentCanvas(canvas, 4);
    const blob = await canvasToBlob(croppedCanvas);
    if (!blob) return null;

    return new File([blob], `${stockFont.fontFamily || "font"}-thumbnail.png`, { type: "image/png" });
};
